import './insert-otp.scss';
import React, {ChangeEvent, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {OTP_REGEX, ROUTES} from '../../constant/constant';
import UserService from '../../service/user-service';
import PersistenceService from '../../service/persistence-service';

function InsertOtp({ isInvalidOTP }: { isInvalidOTP?: boolean }) {

  const navigateTo = useNavigate();
  const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>('');

  // eslint-disable-next-line no-undef
  const digitOTP = (event: ChangeEvent<HTMLInputElement>) => {
    setOtp(event.target.value);
    if (OTP_REGEX.test(event.target.value)) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  };

  const newOTP = async () => {
    const response = await UserService.generateOtp(PersistenceService.getPhoneNumber());
    if (response.code !== 0 && response.code !== -1) {
      navigateTo(response.description ? `${ROUTES.GENERIC_ERROR}/${response.description}` : ROUTES.GENERIC_ERROR);
    }
  }

  const showParagraph = () => {
    if (isInvalidOTP) {
      return (
        <p>
          oppure <Link to={ROUTES.HOME}>Effettua una nuova autenticazione</Link>
        </p>
      );
    }
  };

  const confirm = async () => {
    try {
      setIsButtonEnabled(false);
      const response = await UserService.verifyOtp(otp);
      setIsButtonEnabled(true);
      switch (response.code) {
        case 0: {
          navigateTo(ROUTES.MY_PROFILE);
          break;
        }
        case -1: {
          navigateTo(ROUTES.AUT_CODICE_INVALIDO);
          break;
        }
        case -2: {
          navigateTo(ROUTES.AUT_CODICE_SCADUTO);
          break;
        }
        case -3: {
          navigateTo(`${ROUTES.GENERIC_ERROR}/${response.description}`);
          break;
        }
        default: {
          navigateTo(response.description ? `${ROUTES.GENERIC_ERROR}/${response.description}` : ROUTES.GENERIC_ERROR);
          break;
        }
      }
    } catch (error) {
      navigateTo(`${ROUTES.GENERIC_ERROR}/${error}`);
    }
  };

  return (
    <div className="InsertOtp">
      <p>Inserisci il codice di verifica che hai ricevuto sul numero di cellulare.</p>

      <div className="input-element">
        <span className="input-title">Codice</span>
        <input type="text" size={18} maxLength={6} property="Codice" alt="Codice" onChange={digitOTP} />
      </div>

      <button className="confirm-btn" onClick={confirm} disabled={!isButtonEnabled}>
        Conferma
      </button>

      <div>
        <p>
          Non hai ricevuto il codice di verifica? <Link to={'#'} onClick={ async () => await newOTP()}>Richiedi un nuovo codice</Link>
        </p>
        {showParagraph()}
      </div>
    </div>
  );
}

export default InsertOtp;
